import { currentDevice } from '../../../core/utils/currentDevice.js'
import { initBottomLinks } from '../../../shared/bottom_links/bottom_links'
import { createBottomSheet } from '../../../shared/bottom_sheet/bottom_sheet.js'
import { initDashboardBookingRow } from '../../../shared/dashboard_booking_row/dashboard_booking_row'
import loaderSpinner from '../../../shared/loader_spinner/loader_spinner'
import on from '../../../utils/events_delegation.js'
import watchJob from '../../../utils/watch_job.js'

const getStaragentBookings = () => {
  const $jobIdElement = document.querySelector('.js-staragents-bookings-job-id')

  if (!$jobIdElement) return

  const bookingsJobId = $jobIdElement?.value

  if (!bookingsJobId) return

  const $bookingsContainer = document.querySelector('.js-bookings-container')

  if (!$bookingsContainer) return

  const loaderText = $jobIdElement.dataset.waitText
  const loaderSubText = $jobIdElement.dataset.waitSubtext
  const $loaderContainer = $bookingsContainer.parentElement
  const REPLACEMENT_PROPS = {
    active: 'html_replacements_active',
    inactive: 'html_replacements_not_active',
    canceled: 'html_replacements_canceled',
  }
  const htmlProperties = [REPLACEMENT_PROPS.active, REPLACEMENT_PROPS.inactive, REPLACEMENT_PROPS.canceled]

  // show loaderSpinner
  loaderSpinner.show({
    container: $loaderContainer,
    extraClass: 'mt-7 mb-7',
    title: loaderText,
    subtitle: loaderSubText,
    spinnerColor: 'primary',
  })

  let prefix = document.querySelector('html').getAttribute('prefix')
  prefix = prefix !== '/' ? prefix : ''
  const jobRequestUrl = `${prefix}/star_agent_bookings_jobs/${bookingsJobId}/`

  const handleBookingsResponse = response => {
    if (!response || !response.length) return

    const responseParsed = JSON.parse(response)

    // Concat all html_replacements
    const bookingsHtml = htmlProperties.reduce((previousValue, currentProperty) => {
      const currentHtml = responseParsed[currentProperty]

      if (!currentHtml) return `${previousValue}`

      const currentHtmlParsed = JSON.parse(responseParsed[currentProperty])
      // currentHtmlParsed is an object with all bookings which structure is { booking_id: booking_html }
      // so by obtaining all values and joining them we get all html in a unique string
      const bookingsHtmlList = Object.values(currentHtmlParsed)
      const htmlReplacementSerialized = bookingsHtmlList.join('')

      return previousValue + htmlReplacementSerialized
    }, '')

    if (bookingsHtml.length) {
      // Show bookings container if hidden
      if ($bookingsContainer.classList.contains('is-hidden')) {
        $bookingsContainer.classList.remove('is-hidden')
      }
    }

    // Append html
    $bookingsContainer.innerHTML = bookingsHtml
    IB.currencyForm.forceUpdate($bookingsContainer)
    initBottomLinks()
    initDashboardBookingRow()
  }

  const showFilterSelector = () => {
    const $filterSelector = document.querySelector('.js-bookings-filter')

    if (!$filterSelector) return

    const bookingStatePresence = {
      active: !!$bookingsContainer.querySelector('[data-category="active"]'),
      inactive: !!$bookingsContainer.querySelector('[data-category="not_active"]'),
      canceled: !!$bookingsContainer.querySelector('[data-category="canceled"]'),
    }

    if ($filterSelector.classList.contains('is-hidden')) {
      $filterSelector.classList.remove('is-hidden')
    }

    // Show proper filter options
    $filterSelector
      .querySelector('.js-bookings-filter-active')
      .classList.toggle('is-hidden', !bookingStatePresence['active'])
    $filterSelector
      .querySelector('.js-bookings-filter-inactive')
      .classList.toggle('is-hidden', !bookingStatePresence['inactive'])
    $filterSelector
      .querySelector('.js-bookings-filter-canceled')
      .classList.toggle('is-hidden', !bookingStatePresence['canceled'])
  }

  const showBookingsEmptyWrapper = () => {
    // Hide bookings container and show empty bookings container
    const $bookingsMainWrapper = document.querySelector('.js-bookings-main-wrapper')
    const $emptyBookingsMainWrapper = document.querySelector('.js-bookings-empty-wrapper')
    $bookingsMainWrapper && $bookingsMainWrapper.classList.add('is-hidden')
    $emptyBookingsMainWrapper && $emptyBookingsMainWrapper.classList.remove('is-hidden')
  }

  watchJob({
    url: jobRequestUrl,
    timeout: 1000,
    onPartialResponse: handleBookingsResponse,
    onComplete: response => {
      loaderSpinner.hide({
        container: $loaderContainer,
      })

      // Check if there is any booking
      if (!response || !response.length || !Object.values(JSON.parse(response)).length) {
        showBookingsEmptyWrapper()
      } else {
        const responseParsed = JSON.parse(response)
        const hasHtmlContent = htmlProperties.some(property => {
          if (!responseParsed[property].length) return false

          const htmlObject = JSON.parse(responseParsed[property])
          return !!Object.values(htmlObject).length
        })

        if (hasHtmlContent) {
          // Show bookings
          handleBookingsResponse(response)
          showFilterSelector()
        } else {
          showBookingsEmptyWrapper()
        }
      }
    },
  })
}

getStaragentBookings()

// LEGACY BOOKING MANAGEMENT DIALOG
const LEGACY_BOOKING_DIALOG_ID = 'legacy-star-agents'
if (currentDevice.isMobile) {
  const legacyDialog = document.querySelector(`#${LEGACY_BOOKING_DIALOG_ID}`)

  if (legacyDialog) {
    const legacyBookingSheet = createBottomSheet({ sheetId: LEGACY_BOOKING_DIALOG_ID })

    on({
      eventName: 'click',
      selector: `.link-legacy-star-agents`,
      handler: e => {
        e.preventDefault()
        const triggerElement = e.target
        legacyBookingSheet.show(() => {
          const linkLegacyStarAgents = document.querySelectorAll('.link-legacy-star-agents')
          linkLegacyStarAgents.forEach(element => {
            element.href = triggerElement.dataset.link
          })
        })
      },
    })
  }
} else {
  $(document).on('click', '.link-legacy-star-agents', function (event) {
    event.preventDefault()
    const $el = $(this)

    Modal.show(LEGACY_BOOKING_DIALOG_ID, {
      onShow: () => {
        ScrollLock.on()
        $(`.link-legacy-star-agents`).attr('href', $el.attr('data-link'))
      },
      onClose: () => {
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
    })
  })
}

// CANCEL BOOKING MANAGEMENT DIALOG
if (currentDevice.isMobile) {
  const CANCEL_BOOKING_DIALOG_ID = 'booking-modal-cancel'
  const isCancelBookingDialogPresent = document.querySelector(`#${CANCEL_BOOKING_DIALOG_ID}`)

  if (isCancelBookingDialogPresent) {
    const cancelBookingSheet = createBottomSheet({ sheetId: CANCEL_BOOKING_DIALOG_ID })

    on({
      eventName: 'click',
      selector: `.link-cancel`,
      handler: e => {
        e.preventDefault()
        const triggerElement = e.target
        const cardReservation = triggerElement.closest('.js-block-cnt-child')
        cancelBookingSheet.show(bottomSheet => {
          const cancelLink = bottomSheet.querySelector('.booking-modal-cancel-link')
          if (cancelLink) {
            cancelLink.href = triggerElement.dataset.link
          }

          const modalCancelLink = bottomSheet.querySelector('.js-booking-modal-cancel')
          modalCancelLink?.addEventListener('click', () => {
            if (cardReservation) {
              cardReservation.classList.add('hidden')
            }
            cancelBookingSheet.close()
          })

          const modalClose = bottomSheet.querySelector('.booking-modal-close')
          modalClose?.addEventListener('click', e => {
            e.preventDefault()
            cancelBookingSheet.close()
          })
        })
      },
    })
  }
} else {
  $(document).on('click', '.link-cancel', function (event) {
    event.preventDefault()
    const cardReservation = event.target.closest('.js-block-cnt-child')

    Modal.show('booking-modal-cancel', {
      onShow: modal => {
        ScrollLock.on()
        $(`.booking-modal-cancel-link`).attr('href', $(this).attr('data-link'))

        $(modal).on('click', '.js-booking-modal-cancel', function () {
          cardReservation.classList.add('hidden')
          Modal.close()
        })
      },
      onClose: () => {
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
    })
  })
}

if (!currentDevice.isMobile) {
  $(document).on('click', '.booking-modal-close', function (event) {
    event.preventDefault()
    Modal.close()
  })
}

if ($('.wrapper-flash').length > 0) {
  $('html, body').animate({ scrollTop: $('.wrapper-flash').first().offset().top - 50 }, 500)
}

if (
  $('.js-current-agent-points').length > 0 &&
  IB.browsing_sessions.getData()['redis_values']['sta_points'] !== $('.js-current-agent-points').text()
) {
  IB.browsing_sessions.storeHash({ sta_points: $('.js-current-agent-points').text() }, function (data) {
    if (data !== null) {
      localStorage.setItem('browsing_session', JSON.stringify(data))
    }
  })
}
